export const commonTranslations = {
  HEB: {
    // Wizard
    back: "חזור",

    // Help
    help: "עזרה",
    close: "סגור",

    // MaslekaExpirationPopup
    maslekaExpired: "תוקף המסלקה שלך פג!",
    maslekaExpiredLine1: "עבר יותר משנה מאז חידשת את המסלקה הפנסיונית שלך.",
    maslekaExpiredLine2: "כדי להמשיך לקבל עדכונים על הנכסים הפנסיונים שלך, יש לחדש את המסלקה.",
    maslekaExpiredNote: "המידע הקיים יישאר זמין, אך לא יתעדכן עד לחידוש המסלקה.",
    dontShowAgain: "אל תציג הודעה זו שוב",
    renewNow: "חדש מסלקה עכשיו",

    // OpenFinance connect
    notSupportedInApp: "פעולה זו אינה נתמכת באפליקציה",
    connectViaDesktop: "חיבור חשבונות בנק ואשראי זמין רק דרך מחשב, או דרך דפדפן",
    connectViaDesktopChrome: "Chrome",
    connectViaDesktopSuffix: "בטלפון.",
    understood: "הבנתי",
    returnToApp: "חזרה ל-Moneytor",
    returnToAppDesc: "סיימת את החיבור בבנק. לחצו כדי לחזור לאפליקציה ולהשלים את הייבוא.",

    // Family page
    familyAccount: "חשבון משפחתי",
    familyDescription:
      "הוספת בן משפחה מאפשרת לכם לנהל את הנכסים יחד. תראו את הנכסים והתזרים של שניכם בשני החשבונות.",
    familyDescriptionPremiumInviteeNote:
      " חבר/ת המשפחה שתזמינו יקבל/ו גישה לכל פיצ׳רי הפרימיום.",

    // Index - privacy popup
    privacyDisclaimer: "שימו לב: המידע הפיננסי שאתם מזינים במערכת אינו משותף עם המתכנן הפיננסי שלכם. בהתאם לחוק ולמדיניות הפרטיות שלנו, המידע האישי והפיננסי שלכם נשמר אצלנו בלבד ואינו נגיש לגורמים חיצוניים, לרבות המתכנן. לכן, המתכנן לא יוכל לראות את הנתונים שהזנתם — מומלץ לעדכן אותו ידנית בעת הצורך.",

    refreshing: "מרענן…",
  },
  ENG: {
    // Wizard
    back: "Back",

    // Help
    help: "Help",
    close: "Close",

    // MaslekaExpirationPopup
    maslekaExpired: "Your Pension Masleka Has Expired!",
    maslekaExpiredLine1: "More than a year has passed since you renewed your pension Masleka.",
    maslekaExpiredLine2: "To continue receiving updates on your pension assets, you need to renew the Masleka.",
    maslekaExpiredNote: "Existing data will remain available but will not update until the Masleka is renewed.",
    dontShowAgain: "Don't show this message again",
    renewNow: "Renew Masleka Now",

    // OpenFinance connect
    notSupportedInApp: "This action is not supported in the app",
    connectViaDesktop: "Connecting bank and credit accounts is only available via desktop, or through the",
    connectViaDesktopChrome: "Chrome",
    connectViaDesktopSuffix: "browser on your phone.",
    understood: "Got it",
    returnToApp: "Return to Moneytor",
    returnToAppDesc: "You finished connecting at the bank. Tap to return to the app and complete the import.",

    // Family page
    familyAccount: "Family Account",
    familyDescription:
      "Adding a family member lets you manage your assets together. You'll see each other's assets and cash flow in both accounts.",
    familyDescriptionPremiumInviteeNote:
      " The family member you invite will also get access to all Premium features.",

    // Index - privacy popup
    privacyDisclaimer: "Please note: The financial information you enter in the system is not shared with your financial planner. In accordance with the law and our privacy policy, your personal and financial data is stored only with us and is not accessible to external parties, including your planner. Therefore, the planner cannot see the data you entered — it is recommended to update them manually when needed.",

    refreshing: "Refreshing…",
  },
  RUS: {
    // Wizard
    back: "Назад",

    // Help
    help: "Помощь",
    close: "Закрыть",

    // MaslekaExpirationPopup
    maslekaExpired: "Срок действия вашей пенсионной Маслеки истёк!",
    maslekaExpiredLine1: "Прошло более года с момента обновления вашей пенсионной Маслеки.",
    maslekaExpiredLine2: "Чтобы продолжать получать обновления о ваших пенсионных активах, необходимо обновить Маслеку.",
    maslekaExpiredNote: "Существующие данные останутся доступными, но не будут обновляться до обновления Маслеки.",
    dontShowAgain: "Больше не показывать это сообщение",
    renewNow: "Обновить Маслеку сейчас",

    // OpenFinance connect
    notSupportedInApp: "Это действие не поддерживается в приложении",
    connectViaDesktop: "Подключение банковских и кредитных счетов доступно только через компьютер или через браузер",
    connectViaDesktopChrome: "Chrome",
    connectViaDesktopSuffix: "на вашем телефоне.",
    understood: "Понятно",
    returnToApp: "Вернуться в Moneytor",
    returnToAppDesc: "Вы завершили подключение в банке. Нажмите, чтобы вернуться в приложение и завершить импорт.",

    // Family page
    familyAccount: "Семейный аккаунт",
    familyDescription:
      "Добавление члена семьи позволяет вам управлять активами вместе. Вы будете видеть активы и денежные потоки друг друга в обоих аккаунтах.",
    familyDescriptionPremiumInviteeNote:
      " Приглашённый член семьи также получит доступ ко всем функциям Премиум.",

    // Index - privacy popup
    privacyDisclaimer: "Обратите внимание: финансовая информация, которую вы вводите в систему, не передаётся вашему финансовому планировщику. В соответствии с законом и нашей политикой конфиденциальности, ваши личные и финансовые данные хранятся только у нас и недоступны третьим лицам, включая вашего планировщика. Поэтому планировщик не может видеть введённые вами данные — рекомендуется обновлять информацию вручную при необходимости.",

    refreshing: "Обновление…",
  },
};
